export abstract class AttendanceRepository {
  abstract createPunch(): Promise<void>;
}
